import { combineReducers } from '@reduxjs/toolkit'

import taskReducer from '../slices/auth/taskSlice';
import loginReducer from '../slices/auth/loginSlice';
import resetPasswordReducer from '../slices/auth/resetPasswordSlice';
import choosePasswordReducer from '../slices/auth/choosePasswordSlice';
import resendEmailCodeReducer from '../slices/auth/resendEmailCodeSlice';
import resendSMSCodeReducer from '../slices/auth/resendSMSCodeSlice';
import updateDetailsReducer from "../slices/myprofile/updateDetailsSlice";
import verifyReducer from "../slices/auth/verifyCodeSlice";

import supplierCreateReducer from '../slices/suppliers/addSlice';
import supplierUpdateReducer from '../slices/suppliers/updateSlice';
import supplierUpdateNotificationsMobileNumberReducer from "../slices/suppliers/updateNotificationsMobileNumberSlice";
import userCreateReducer from '../slices/users/addSlice';
import userUpdateReducer from '../slices/users/updateSlice';
import respondToConsumerReducer from '../slices/auth/respondToQuoteSlice';

import submitQuoteReducer from '../slices/quoterequests/addSlice';
import updateQuoteReducer from '../slices/quoterequests/updateSlice';
import withdrawQuoteReducer from '../slices/quoterequests/withdrawSlice';

//Business Profile
import businessProfileReducer from '../slices/businessprofile/detailsSlice';
import businessProfileUpdateReducer from '../slices/businessprofile/updateDetailsSlice';
import dialogReducer from "../slices/general/dialogSlice";
import uploadFileReducer from "../slices/general/uploadFileSlice";

// calendar reducers
import fetchCalendarReducer from '../slices/calendar/fetchSlice';
import addCalendarReducer from '../slices/calendar/addSlice';
import updateCalendarReducer from '../slices/calendar/updateSlice';
import deleteCalendarReducer from '../slices/calendar/deleteSlice';


const rootReducer = combineReducers({
    
    login: loginReducer,
    reset: resetPasswordReducer,
    choose: choosePasswordReducer,
    resend_email: resendEmailCodeReducer,
    resend_sms: resendSMSCodeReducer,
    profile: updateDetailsReducer,
    task: taskReducer,
    verify: verifyReducer,
    supplier_create: supplierCreateReducer,
    supplier_update: supplierUpdateReducer,
    supplier_update_notifications_mobile_number: supplierUpdateNotificationsMobileNumberReducer,
    quote_respond: respondToConsumerReducer,
    uploadFile: uploadFileReducer,

    user_create: userCreateReducer,
    user_update: userUpdateReducer,
    business_profile: businessProfileReducer,
    business_profile_update: businessProfileUpdateReducer,
    submit_quote: submitQuoteReducer,
    update_quote: updateQuoteReducer,
    withdraw_quote: withdrawQuoteReducer,
    dialog: dialogReducer,
    calendar_fetch: fetchCalendarReducer,
    calendar_add: addCalendarReducer,
    calendar_update: updateCalendarReducer,
    calendar_delete: deleteCalendarReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
